import Partners from '@/pages/partners/Partners'
import CreatePartner from '@/pages/partners/CreatePartner'
import EditPartner from '@/pages/partners/EditPartner'

const routes = [
  {
    path: '/partners',
    name: 'Partners',
    component: Partners,
    meta: {
      requiresAuthentication: true,
      roleRequired: ['ROLE_ADMIN']
    }
  },
  {
    path: '/create-partner',
    name: 'CreatePartner',
    component: CreatePartner,
    meta: {
      requiresAuthentication: true,
      roleRequired: ['ROLE_ADMIN']
    }
  },
  {
    path: '/edit-partner/:id',
    name: 'EditPartner',
    component: EditPartner,
    meta: {
      requiresAuthentication: true,
      roleRequired: ['ROLE_ADMIN']
    },
    props: true
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/router/partners.js